<template>
  <div data-group="equipment-archive" class="m-filterCollapse__item js-blockCollapse" v-bind:class="(filter_state.equipment_type) ? 'is-open' : ''">
    <button v-on:click="updateFilter" type="button" class="m-filterCollapse__toggle Editable js-blockCollapseToggle">
      <span class="-title">{{ equipment_type_title }}</span>
      <span class="-icon">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M24 24H0V0h24v24z" fill="none" opacity=".87"/><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/></svg>
      </span>
    </button>
    <transition
      name="accordions-fade"
      v-on:after-enter="afterEnter"
      v-on:after-leave="afterLeave"
    >
      <div v-show="filter_row_state.equipment_type">
        <div>
          <div class="m-filterCollapse__inner__content">
            <div class="c-FormElement--checkboxIcon" v-for="type in types"   v-bind:key="type.term_id">
              <input  v-model="inputVal" :id="'el-'+type.term_id" type="checkbox" placeholder="Texte" :value="type.term_id">
              <label :for="'el-'+type.term_id">{{type['type_equipement_title_' + lang]}}</label>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "FilterEquipmentType",
  props: ['types', 'selection_equipment_type_values', 'filter_row_state'],
  data() {
    return {
      collapse: true,
      filter_state: this.filter_row_state,
      // translation
      lang: window.Store.app.lang,
      equipment_type_title: window.Store.translate_strings.filter ? window.Store.translate_strings.filter.equipment_type_title : '',
    }
  },
  computed : {
    inputVal: {
      get() {
        return this.selection_equipment_type_values;
      },
      set(val) {
        this.$emit('selection_equipment_type_values', val);
      }
    }
  },
  methods: {
    updateFilter: function() {
      this.filter_state.equipment_type = !this.filter_state.equipment_type;
      this.filter_state.product_line = false;
      this.filter_state.body_part = false;
      this.filter_state.recently_launched = false;
      this.$emit('update:filter_row_state', this.filter_state);
    },
    /**
     * after enter
     */
    afterEnter: function() {
      window.Store.scrollbar.element.update();
    },
    /**
     * after leave
     */
    afterLeave: function() {
      window.Store.scrollbar.element.update();
    }
  }
}
</script>

<style scoped>

</style>
